<template>
    <v-container>
        <v-row>
            <v-dialog v-model="dialog" persistent>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="hubblue" dark large v-bind="attrs" v-on="on" @click="resetDistributionListData">
                        <v-icon class="pr-2">mdi-plus</v-icon>
                        Add New Distribution List
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">Create New Distribution List</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form ref="form" @submit.prevent="addReviewerEmailToList()">
                                <v-flex class="xs12 mt-1">
                                    <v-text-field
                                        v-model="emailListName"
                                        label="Save Distribution List As*"
                                        :counter="50"
                                        v-validate="'required'"
                                        :error-messages="errors.collect('distributionListName')"
                                        data-vv-name="distributionListName"
                                        data-cy="txtDistributionListName"
                                    ></v-text-field>
                                </v-flex>
                                <v-text-field
                                    v-model="email"
                                    label="Reviewer Email*"
                                    :counter="50"
                                    :error-messages="errors.collect('email')"
                                    v-validate="'required|email'"
                                    data-vv-name="email"
                                    data-cy="txtEmail"
                                ></v-text-field>
                                <v-row class="xs12 px-3">
                                    <v-checkbox
                                        class="xs4 pr-5"
                                        v-model="cc"
                                        label="CC (Approval Not Required)"
                                        color="hubblue"
                                    ></v-checkbox>

                                    <v-checkbox
                                        class="xs4 pr-5"
                                        v-model="superApprover"
                                        label="Super Approver (Document Considered Fully Approved Once User Approvers)"
                                        color="hubblue"
                                        :disabled="superApproverDisabled"
                                        v-if="showSuperApprover"
                                    ></v-checkbox>

                                    <v-flex class="justify-right xs4 mt-3">
                                        <v-btn class="hubblue" dark type="submit" data-cy="btnSave">
                                            <v-icon class="pr-2">mdi-account-plus</v-icon>
                                            Add Email
                                        </v-btn>
                                    </v-flex>
                                </v-row>
                            </v-form>
                            <v-row class="xs12 pl-3">
                                <v-col cols="12">
                                    <v-row class="pr-3">
                                        <!-- required -->
                                        <v-flex>
                                            <v-card class="pa-3 mr-3">
                                                <b>Approver</b>
                                                <v-divider class="mb-2" />
                                                <template v-for="(email, idx) in emailList">
                                                    <v-row :key="idx">
                                                        <v-btn class="mx-1" icon @click="removeFromList(idx)">
                                                            <v-icon>mdi-close</v-icon>
                                                        </v-btn>
                                                        <span class="pt-1"
                                                            >{{ email.email }}
                                                            <span v-if="email.superApprover">
                                                                is Super Approver
                                                            </span>
                                                        </span>
                                                    </v-row>
                                                </template>
                                            </v-card>
                                        </v-flex>

                                        <!-- not required -->
                                        <v-flex>
                                            <v-card class="pa-3">
                                                <b>CC'd</b>
                                                <v-divider class="mb-2" />
                                                <template v-for="(email, index) in emailListNR">
                                                    <v-row :key="index">
                                                        <v-btn class="mx-1" icon @click="removeFromListNR(index)">
                                                            <v-icon>mdi-close</v-icon>
                                                        </v-btn>
                                                        <span class="pt-1">{{ email }}</span>
                                                    </v-row>
                                                </template>
                                            </v-card>
                                        </v-flex>
                                    </v-row>
                                    <v-row>
                                        <v-flex xs12 sm6 lg2 d-flex>
                                            <v-select
                                                ref="tag"
                                                class="mb-0 pb-0"
                                                hide-details
                                                :items="tags"
                                                item-value="id"
                                                item-text="name"
                                                label="Add Tag (optional)"
                                                v-model="selectedTag"
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs12 sm6 lg2 d-flex>
                                            <v-textarea
                                                v-show="selectedTag !== null"
                                                class="mx-2"
                                                rows="1"
                                                v-model="tagDetail"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('tagDetail')"
                                                data-vv-name="tagDetail"
                                                data-cy="txtTagDetail"
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex class="justify-right xs4 mt-3" v-show="selectedTag !== null">
                                            <v-btn color="hubblue" dark @click="addNewTag">
                                                <v-icon class="pr-2">mdi-plus</v-icon>
                                                Add Tag
                                            </v-btn>
                                        </v-flex>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row class="pr-3" v-if="showTagList">
                                <v-col cols="4">
                                    <v-flex>
                                        <v-card class="pa-3 mr-3">
                                            <b>Tags</b>
                                            <v-divider class="mb-2" />
                                            <template v-for="(tag, idx) in tagList">
                                                <v-row :key="idx">
                                                    <v-btn class="mx-1" icon @click="removeFromTagList(tag, idx)">
                                                        <v-icon>mdi-close</v-icon>
                                                    </v-btn>
                                                    <span class="pt-1"
                                                        >{{ tag.tagName }} :
                                                        <span class="pt-1">
                                                            {{ tag.tagContent }}
                                                        </span>
                                                    </span>
                                                </v-row>
                                            </template>
                                        </v-card>
                                    </v-flex>
                                </v-col>
                            </v-row>
                        </v-container>
                        <small>*indicates required field</small>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDialog">Close</v-btn>
                        <v-btn color="blue darken-1" text @click="saveDistributionList">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-spacer></v-spacer>
        <v-divider class="mx-4" :inset="inset" vertical></v-divider>

        <v-flex class="xs12">
            <v-data-table
                :headers="headers"
                :items="dataForTable"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                :search="keyword"
                item-key="emailListName"
                show-expand
                class="elevation-1"
            >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Your Distribution Lists</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="pt-0 pb-2 pr-2">
                        <v-layout>
                            <v-flex xs4>
                                <v-text-field
                                    append-icon="mdi-search"
                                    label="Search"
                                    single-line
                                    hide-details
                                    v-model="keyword"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </template>
                <!-- <template v-slot:item.emailListName="{ item }">{{ item.emailListName }}</template> -->
                <template v-slot:item.companyEmailListId="{ item }">
                    <v-btn icon @click.native="openEmailListDialog(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </template>
                <template v-slot:item.companyEmailListIdRemove="{ item }">
                    <v-btn icon @click.native="openConfirmDialogList(item.companyEmailListIdRemove)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
                <template v-slot:item.companyEmailListAddEmail="{ item }">
                    <v-btn icon @click.native="openAddEmailToListDialog(item)">
                        <v-icon>mdi-email-plus</v-icon>
                    </v-btn>
                </template>

                <template v-slot:expanded-item="{ item }">
                    <td :colspan="headers.length + 3">
                        <table>
                            <tr>
                                <td style="font-weight:bold">Email</td>
                                <td style="font-weight:bold">Role</td>
                                <td style="font-weight:bold">Edit</td>
                                <td style="font-weight:bold">Remove</td>
                            </tr>

                            <tr v-for="(record, index) in item.companyEmailListDetail" :key="index">
                                <td>{{ item.arrayCompanyEmailListDetail[index].email }}</td>
                                <td>
                                    {{
                                        item.arrayCompanyEmailListDetail[index].superApprover === true
                                            ? 'Super Approver'
                                            : item.arrayCompanyEmailListDetail[index].cc === false
                                            ? 'Approver'
                                            : "CC'd"
                                    }}
                                </td>
                                <td>
                                    <v-btn icon @click.native="openEmailListDetailDialog(item, index)">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </td>
                                <td>
                                    <v-btn
                                        icon
                                        @click.native="
                                            openConfirmDialog(
                                                item.arrayCompanyEmailListDetail[index].companyEmailListDetailId
                                            )
                                        "
                                    >
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </table>
                    </td>
                </template>
            </v-data-table>
        </v-flex>
        <v-dialog v-model="confirmRemoveList" max-width="450px">
            <v-card>
                <v-flex xs12>
                    <v-card-title class="hubblue white--text">Are you sure you want to remove?</v-card-title>
                </v-flex>
                <v-card-actions>
                    <v-btn class="blue--text darken-1" @click.native="confirmRemoveList = false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="blue--text darken-1" @click.native="update('removeList')" data-cy="btnConfirmArchive"
                        >Confirm</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmRemove" max-width="450px">
            <v-card>
                <v-flex xs12>
                    <v-card-title class="hubblue white--text">Are you sure you want to remove?</v-card-title>
                </v-flex>
                <v-card-actions>
                    <v-btn class="blue--text darken-1" @click.native="confirmRemove = false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="blue--text darken-1" @click.native="update('remove')">
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="emailListDetailDialog" max-width="550px">
            <v-card>
                <v-flex xs12>
                    <v-card-title class="hubblue white--text">Email</v-card-title>
                </v-flex>
                <v-card-text>
                    <v-row align="center">
                        <v-text-field
                            v-model="emailUpdate"
                            label="Email"
                            :counter="50"
                            :error-messages="errors.collect('emailUpdate')"
                            v-validate="'required|email'"
                            data-vv-name="emailUpdate"
                            data-cy="txtEmail"
                        ></v-text-field>
                    </v-row>
                    <v-row align="center">
                        <v-checkbox
                            v-model="ccUpdate"
                            label="CC (Approval Not Required)"
                            color="hubblue"
                            :disabled="superApproverUpdate"
                        ></v-checkbox>
                        <v-checkbox
                            v-model="superApproverUpdate"
                            label="Super Approver (Document Considered Fully Approved Once User Approvers)"
                            color="hubblue"
                            v-if="showSuperApprover"
                            :disabled="ccUpdate === true"
                        ></v-checkbox>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="blue--text darken-1" @click.native="emailListDetailDialog = false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="blue--text darken-1" @click.native="save()">
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="emailListDialog" max-width="550px">
            <v-card>
                <v-flex xs12>
                    <v-card-title class="hubblue white--text">Distribution List Details</v-card-title>
                </v-flex>
                <v-card-text class="mb-0 pb-0 ">
                    <v-row align="center">
                        <v-text-field
                            v-model="emailListNameUpdate"
                            label="List Name"
                            v-validate="'required'"
                            :counter="50"
                            :error-messages="errors.collect('emailListNameUpdate')"
                            data-vv-name="emailListNameUpdate"
                            data-cy="txtListName"
                        ></v-text-field>
                    </v-row>
                </v-card-text>
                <v-card-text class="mb-4 pb-4 mt-0">
                    <v-row>
                        <v-flex xs12 sm6 lg4 d-flex>
                            <v-select
                                class="mb-0 pb-0"
                                hide-details
                                :items="tagsUpdateOptions"
                                item-value="id"
                                item-text="name"
                                label="Add More Tags"
                                v-model="selectedTagEdit"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 lg4 d-flex>
                            <v-textarea
                                v-if="selectedTagEdit !== null"
                                class="mx-2"
                                rows="1"
                                v-model="newTagDetial"
                                v-validate="'required'"
                                :error-messages="errors.collect('tagDetailUpdate')"
                                data-vv-name="tagDetailUpdate"
                                data-cy="txtTagDetailUpdate"
                            ></v-textarea>
                        </v-flex>
                        <v-flex class="justify-right xs4 mt-3" v-if="selectedTagEdit !== null">
                            <v-btn color="hubblue" dark @click="addNewTagToUpdate">
                                <v-icon class="pr-2">mdi-plus</v-icon>
                                Add Tag
                            </v-btn>
                        </v-flex>
                    </v-row>
                </v-card-text>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>

                <v-expansion-panels focusable :value="[0]" multiple>
                    <v-expansion-panel>
                        <v-expansion-panel-header>Current Distribution List Tags</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-chip
                                v-for="(tagDetail, index) in emailListTagsUpdate"
                                :key="index"
                                class="ma-2"
                                close
                                @click:close="removeTag(index)"
                            >
                                {{ tagDetail.tag.tagName }} : {{ tagDetail.tagDetailContent }}
                            </v-chip>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <v-card-actions>
                    <v-btn class="blue--text darken-1" @click.native="closeEmailListDialog">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="blue--text darken-1" @click.native="saveEdit()" data-cy="btnConfirmArchive"
                        >Confirm</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { authHeader } from '../_helpers'

export default {
    $_veeValidate: {
        validator: 'new' // give me a new validator each time.
    },
    data() {
        return {
            loading: false,

            inset: false,

            originalTags: [],
            tags: [],
            selectedTag: null,
            tagDetail: '',
            showTagList: false,
            tagList: [],
            originalTagListEdit: [],
            selectedTagEdit: null,
            newTagDetial: '',
            tagsUpdateOptions: [],

            emailList: [],
            emailListNR: [],
            emailData: {},
            emailListName: null,

            dialog: false,

            email: '',
            cc: false,
            superApprover: false,
            showSuperApprover: true,
            superApproverDisabled: false,

            snackbar: false,
            snackbarMessage: null,
            snackbarContext: '',

            dataForTable: [],
            keyword: null,
            expanded: [],
            singleExpand: true,

            confirmRemove: false,
            emailDetailForRemoving: null,

            emailListDetailDialog: false,
            emailListDetailUpdate: null,
            emailUpdate: null,
            ccUpdate: false,
            superApproverUpdate: false,

            emailListEdit: null,
            emailListDialog: false,
            emailListNameUpdate: null,
            emailListTagsUpdate: [],
            emailListTagsToRemoveIds: [],

            addEmailToList: false,

            confirmRemoveList: false,
            listForRemoving: null,

            headers: [
                {
                    text: 'List Name',
                    value: 'emailListName'
                },
                {
                    text: 'Edit',
                    value: 'companyEmailListId'
                },
                {
                    text: 'Remove',
                    value: 'companyEmailListIdRemove'
                },
                {
                    text: 'Add Email',
                    value: 'companyEmailListAddEmail'
                },
                { text: '', value: 'data-table-expand' }
            ]
        }
    },
    methods: {
        closeEmailListDialog() {
            this.emailListTagsUpdate = this.originalTagListEdit
            this.selectedTagEdit = null
            this.emailListDialog = false
        },
        removeTag(toRemove) {
            let removedTag = this.emailListTagsUpdate[toRemove]
            this.tagsUpdateOptions.push({ id: removedTag.tag.tagId, name: removedTag.tag.tagName })
            this.emailListTagsToRemoveIds.push(this.emailListTagsUpdate[toRemove].tagDetailId)
            this.emailListTagsUpdate.splice(toRemove, 1)
        },
        resetDistributionListData() {
            this.emailList = []
            this.emailListNR = []
            this.emailData = {}
            this.emailListName = null
            this.superApproverUpdate = false
            this.ccUpdate = false
            this.cc = false
            this.tags = [...this.originalTags]
        },
        addNewTag() {
            this.$validator.validate('tagDetail', this.tagDetail).then(validated => {
                if (validated) {
                    this.showTagList = true
                    let tag = this.tags.find(tag => tag.id === this.selectedTag)
                    this.tagList.push({
                        tagId: tag.id,
                        tagName: tag.name,
                        tagContent: this.tagDetail
                    })
                    //remove the tag that has already been added, one tag can only be selected once
                    let index = this.tags.map(tag => tag.id).indexOf(this.selectedTag)
                    this.tags.splice(index, 1)
                    this.selectedTag = null
                    this.tagDetail = ''
                }
            })
        },
        addNewTagToUpdate() {
            this.$validator.validate('tagDetailUpdate', this.newTagDetial).then(validated => {
                if (validated) {
                    let tag = this.tagsUpdateOptions.find(tag => tag.id === this.selectedTagEdit)
                    let index = this.tagsUpdateOptions.map(tag => tag.id).indexOf(this.selectedTagEdit)
                    this.emailListTagsUpdate.push({
                        tagDetailContent: this.newTagDetial,
                        tag: { tagId: tag.id, tagName: tag.name }
                    })
                    this.selectedTagEdit = null
                    this.newTagDetial = ''
                }
            })
        },
        closeDialog() {
            this.emailList = []
            this.emailListNR = []
            this.emailData = {}
            this.tagList = []
            this.emailListName = null
            this.ccUpdate = false
            this.cc = false
            this.$refs.form.reset()
            this.errors.clear()
            this.dialog = false
        },
        disableSuperApprover(cc) {
            if (cc) {
                this.superApprover = false
                this.superApproverDisabled = true
            } else {
                this.superApproverDisabled = false
            }
        },
        removeFromList(index) {
            let emailListData = this.emailList[index]
            if (this.emailData[emailListData.email].superApprover) {
                this.superApproverDisabled = false
                this.superApprover = false
                this.showSuperApprover = true
            }
            delete this.emailData[emailListData.email]
            this.emailList.splice(index, 1)
        },
        removeFromTagList(tag, index) {
            let foundOriginalTag = this.originalTags.find(originalTag => originalTag.name === tag.tagName)
            this.tags.splice(index, 0, foundOriginalTag)
            this.tagList.splice(index, 1)
            this.tags.sort((a, b) => a.id - b.id)
            if (this.tagList.length === 0) {
                this.showTagList = false
            }
        },
        removeFromListNR(index) {
            let emailAddress = this.emailListNR[index]
            delete this.emailData[emailAddress]
            this.emailListNR.splice(index, 1)
        },
        createEmailList() {
            const app = this
            let snackbarParams
            let params = {
                companyId: app.$store.state.authentication.loggedInUser.companyId,
                emailData: JSON.stringify(app.emailData),
                emailListName: app.emailListName,
                tagList: JSON.stringify(this.tagList)
            }

            let headers = {
                headers: {
                    Authorization: JSON.parse(localStorage.getItem('user'))
                }
            }
            axios
                .post(app.$store.state.companyEmailListUrl + '/create', params, headers)
                .then(response => {
                    snackbarParams = {
                        message: `Distribution List: ${app.emailListName} Has Been Created Successfully`,
                        context: 'success'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                    app.get()
                    app.emailList = []
                    app.emailListNR = []
                    app.emailData = {}
                    app.emailListName = null
                })
                .catch(error => {
                    console.log(error)
                    app.loading = false
                    snackbarParams = {
                        message: error.response.data,
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                    app.emailList = []
                    app.emailListNR = []
                    app.emailData = {}
                    app.emailListName = null
                    app.superApproverUpdate = false
                    app.ccUpdate = false
                    app.cc = false
                })
        },
        saveDistributionList() {
            let app = this
            app.$validator.validate('distributionListName', this.emailListName).then(validated => {
                if (validated && (this.emailListNR.length > 0 || this.emailList.length > 0)) {
                    this.createEmailList()
                    app.dialog = false
                    app.tagList = []
                } else {
                    let snackbarParams = {
                        message: 'Failed to Create Document, Check Invalid Fields',
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                }
            })
        },
        addReviewerEmailToList() {
            this.$validator
                .validate('email', this.email)
                .then(validated => {
                    if (validated) {
                        let index = this.emailList.findIndex(record => {
                            return record.email === this.email
                        })

                        let index2 = this.emailListNR.findIndex(record => {
                            return record.email === this.email
                        })

                        if (index < 0 && index2 < 0) {
                            if (this.cc === false) {
                                this.emailList.push({
                                    email: this.email,
                                    superApprover: this.superApprover
                                })
                            } else {
                                this.emailListNR.push(this.email)
                            }
                            this.emailData[this.email] = {
                                cc: this.cc,
                                superApprover: this.superApprover
                            }
                        } else {
                            let snackbarParams = {
                                message: 'Email already in the list.',
                                context: 'orange'
                            }

                            this.$store.commit('showSnackbar', snackbarParams)
                        }
                        this.email = ''
                        this.cc = false
                        //only want one super approver per document, hide that option if one was added
                        if (this.superApprover) {
                            this.superApprover = false
                            this.showSuperApprover = false
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                    return false
                })
        },
        openEmailListDetailDialog(item, index) {
            let emailListDetail = item.arrayCompanyEmailListDetail[index]
            let hasSuperApprover = false

            for (let i = 0; i < item.arrayCompanyEmailListDetail.length; i++) {
                if (item.arrayCompanyEmailListDetail[i].superApprover === true) {
                    hasSuperApprover = true
                    break
                }
            }
            this.emailListDetailUpdate = emailListDetail
            this.addEmailToList = false
            this.emailUpdate = emailListDetail.email
            this.ccUpdate = emailListDetail.cc

            if (hasSuperApprover === false || emailListDetail.superApprover === true) {
                this.showSuperApprover = true
                this.superApproverUpdate = emailListDetail.superApprover
            } else {
                this.showSuperApprover = false
            }

            this.emailListDetailDialog = true
        },
        openAddEmailToListDialog(item) {
            this.emailListEdit = item
            this.addEmailToList = true
            this.emailUpdate = null
            this.ccUpdate = false
            this.emailListDetailDialog = true
        },
        openConfirmDialog(item) {
            this.emailDetailForRemoving = item
            this.confirmRemove = true
        },
        openConfirmDialogList(item) {
            this.listForRemoving = item
            this.confirmRemoveList = true
        },
        openEmailListDialog(item) {
            this.emailListEdit = item
            this.emailListNameUpdate = item.emailListName
            if (item.tagDetails) {
                this.emailListTagsUpdate = item.tagDetails.map(tagDetail => ({ ...tagDetail }))
                this.originalTagListEdit = item.tagDetails.map(tagDetail => ({ ...tagDetail }))
            }

            this.emailListDialog = true
        },
        getAllTags() {
            axios
                .get(this.$store.state.tagUrl, {
                    headers: authHeader()
                })
                .then(response => {
                    let allTags = []
                    for (let tag of response.data) {
                        allTags.push({ id: tag.tagId, name: tag.tagName })
                    }
                    this.originalTags = [...allTags]
                    this.tags = allTags
                })
        },
        get() {
            this.dataForTable = []
            axios
                .get(
                    this.$store.state.companyEmailListUrl +
                        '/' +
                        this.$store.state.authentication.loggedInUser.companyId,
                    {
                        headers: authHeader()
                    }
                )
                .then(response => {
                    if (response.data.length > 0) {
                        for (let index = 0; index < response.data.length; index++) {
                            let _data = {
                                companyEmailListId: response.data[index].companyEmailListId,
                                companyEmailListIdRemove: response.data[index].companyEmailListId,
                                emailListName: response.data[index].listName,
                                companyEmailListDetail: response.data[index].companyEmailListDetail,
                                arrayCompanyEmailListDetail: Array.from(response.data[index].companyEmailListDetail),
                                tagDetails: response.data[index].tagDetails
                            }
                            this.dataForTable.push(_data)
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                    let snackbarParams = {
                        message: error.message,
                        context: 'error'
                    }
                    this.$store.commit('showSnackbar', snackbarParams)
                })
        },
        update(field) {
            this.loading = true
            const app = this
            let params = {}
            let baseUrl = this.$store.state.companyEmailListUrl

            if (field === 'update') {
                params = {
                    companyEmailListId: app.emailListEdit.companyEmailListId,
                    emailListName: app.emailListNameUpdate,
                    emailListTagList: app.emailListTagsUpdate,
                    emailListTagsToRemoveIds: app.emailListTagsToRemoveIds
                }
            }

            if (field === 'updateDetail') {
                params = {
                    companyEmailListDetailId: app.emailListDetailUpdate.companyEmailListDetailId,
                    email: app.emailUpdate,
                    cc: app.ccUpdate,
                    superApprover: app.superApproverUpdate
                }
                baseUrl = this.$store.state.companyEmailListUrl + '/companyemaildetail'
            }

            if (field === 'remove') {
                params = {
                    companyEmailListDetailId: app.emailDetailForRemoving
                }
                baseUrl = this.$store.state.companyEmailListUrl + '/companyemaildetail'
            }

            if (field === 'removeList') {
                params = {
                    companyEmailListId: app.listForRemoving
                }
                baseUrl = this.$store.state.companyEmailListUrl + '/removelist'
            }

            axios
                .patch(
                    baseUrl,
                    {
                        params: params
                    },
                    { headers: authHeader() }
                )
                .then(response => {
                    app.loading = false

                    app.emailDetailForRemoving = null
                    app.confirmRemove = false

                    app.emailListDetailUpdate = null
                    app.emailUpdate = null
                    app.ccUpdate = false
                    app.superApproverUpdate = false
                    app.emailListDetailDialog = false

                    app.emailListEdit = null
                    app.emailListDialog = false
                    app.emailListNameUpdate = null

                    app.listForRemoving = null
                    app.confirmRemoveList = false

                    app.selectedTagEdit = null
                    app.emailListTagsToRemoveIds = []
                    let snackbarParams = {
                        message: response.data,
                        context: 'success'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                    app.get()
                })
                .catch(error => {
                    console.log(error)
                    app.loading = false
                    let snackbarParams = {
                        message: error.response.data,
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                })
        },
        addToList() {
            let app = this

            let params = {
                companyEmailListId: app.emailListEdit.companyEmailListId,
                email: app.emailUpdate,
                cc: app.ccUpdate,
                superApprover: app.superApproverUpdate
            }

            axios
                .patch(
                    app.$store.state.companyEmailListUrl + '/addtolist',
                    {
                        params: params
                    },
                    { headers: authHeader() }
                )
                .then(response => {
                    app.loading = false

                    app.emailUpdate = null
                    app.ccUpdate = false
                    app.superApproverUpdate = false
                    app.emailListDetailDialog = false
                    app.emailListEdit = null
                    app.addEmailToList = false

                    let snackbarParams = {
                        message: response.data,
                        context: 'success'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)

                    app.get()
                })
                .catch(error => {
                    console.log(error)
                    app.loading = false

                    let snackbarParams = {
                        message: error.response.data,
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                })
        },
        saveEdit() {
            let app = this
            app.$validator.validate('emailListNameUpdate', this.emailListNameUpdate).then(validated => {
                if (validated) {
                    app.update('update')
                }
            })
        },
        save() {
            let app = this
            app.$validator
                .validateAll()
                .then(validated => {
                    if (validated) {
                        if (app.addEmailToList === true) {
                            app.addToList()
                        }
                        if (app.emailListNameUpdate === null) {
                            app.update('updateDetail')
                        } else {
                            app.update('update')
                        }
                    }
                })
                .catch(() => {
                    return false
                })
        }
    },
    watch: {
        emailListTagsUpdate() {
            this.tagsUpdateOptions = [...this.originalTags]
            let difference = this.tagsUpdateOptions.filter(
                item1 => !this.emailListTagsUpdate.some(item2 => item2.tag.tagId === item1.id)
            )
            this.tagsUpdateOptions = difference
        }
    },
    created() {
        this.get()
        this.getAllTags()
    }
}
</script>
